import { render, staticRenderFns } from "./UserNonWorkingDays.vue?vue&type=template&id=590838e3"
import script from "./UserNonWorkingDays.vue?vue&type=script&lang=js"
export * from "./UserNonWorkingDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports